module.exports = __webpack_public_path__ + "img/1002.c7510238.jpg";